import React, { useState } from "react";
import "./index.scss";
import { NavItems } from "@components/navItems";
import { Modal } from "react-bootstrap";
import ToggleSwitch from "@components/Home/ToggleSwitchLang/ToggleSwitchLang";
export const MobileMenu = ({ showModal, toggleModal }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  return (
    <div className="menu-mobile">
      <Modal
        show={showModal}
        onHide={toggleModal}
        dialogClassName="fade-left-modal"
        className="modal-menu "
        style={{ "--bs-modal-margin": "0" }}>
        <Modal.Body>
          <div className="d-flex flex-column   ">
            <div className="sidebar-card-title mb-5 ">
              <h1 className="sidebar-title">INVOICIA</h1>
              <ToggleSwitch />
            </div>{" "}
            <NavItems
              isCollapsed={isCollapsed}
              toggleSidebar={() => setIsCollapsed(!isCollapsed)}
            />
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};
